import React from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import PageHeader from "../../components/PageHeader";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import ManualInvoicesTable from "../../components/Tables/ManualInvoicesTable";

class ManualInvoiceList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: false,
      filters: {
        status: '',
      }
    };
  }

  render() {
    const { filters } = this.state;
    const { userPermissions } = this.props;
    const userHasNewManualInvoicePermission = userPermissions.includes('new service');

    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Manuel Faturalar"
              Breadcrumb={[
                { name: "Faturalar", navigate: "" },
                { name: "Manuel Faturalar", navigate: "" },
              ]}
            />

            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <div className="header">
                    <h2>
                      <i className="icon-doc text-primary"></i> Manuel Faturalar
                    </h2>
                    <small className="text-muted">Manuel olarak oluşturulan tüm faturalar</small>
                    {userHasNewManualInvoicePermission ? (
                      <Dropdown as="ul" className="header-dropdown">
                        <Dropdown.Toggle
                          variant="success"
                          as="li"
                          id="dropdown-basic"
                        >
                          <i className="icon-plus text-success p-1 ml-1"></i>
                          <Dropdown.Menu
                            as="ul"
                            className="dropdown-menu dropdown-menu-right"
                          >
                            <li>
                              <Link to="/manual-invoice">Yeni Manuel Fatura</Link>
                            </li>
                          </Dropdown.Menu>
                        </Dropdown.Toggle>
                      </Dropdown>
                    ) : ""}
                  </div>
                  <div className="body">
                    {/* Durum Badge'leri */}
                    <div className="row clearfix mb-3">
                      <div className="col-12">
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                          <button
                            className={`btn btn-sm ${filters.status === '' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => this.setState({ filters: { status: '' } })}
                          >
                            <i className="icon-doc"></i> Tümü
                          </button>
                          <button
                            className={`btn btn-sm ${filters.status === 'draft' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => this.setState({ filters: { status: 'draft' } })}
                          >
                            <i className="icon-note"></i> Taslak
                          </button>
                          <button
                            className={`btn btn-sm ${filters.status === 'running' ? 'btn-warning' : 'btn-outline-warning'}`}
                            onClick={() => this.setState({ filters: { status: 'running' } })}
                          >
                            <i className="icon-clock"></i> İşlemde
                          </button>
                          <button
                            className={`btn btn-sm ${filters.status === 'done' ? 'btn-success' : 'btn-outline-success'}`}
                            onClick={() => this.setState({ filters: { status: 'done' } })}
                          >
                            <i className="icon-check"></i> Tamamlanmış
                          </button>
                          <button
                            className={`btn btn-sm ${filters.status === 'cancel' ? 'btn-danger' : 'btn-outline-danger'}`}
                            onClick={() => this.setState({ filters: { status: 'cancel' } })}
                          >
                            <i className="icon-close"></i> İptal Edilmiş
                          </button>
                          <button
                            className={`btn btn-sm ${filters.status === 'error' ? 'btn-danger' : 'btn-outline-danger'}`}
                            onClick={() => this.setState({ filters: { status: 'error' } })}
                          >
                            <i className="icon-exclamation"></i> Hatalı
                          </button>
                          <button
                            className={`btn btn-sm ${filters.status === 'unknown' ? 'btn-secondary' : 'btn-outline-secondary'}`}
                            onClick={() => this.setState({ filters: { status: 'unknown' } })}
                          >
                            <i className="icon-question"></i> Diğer
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="row clearfix">
                      <div className="col-lg-12 col-md-12">
                        <ManualInvoicesTable status={filters.status} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <style>
              {`
                #dropdown-basic::after {
                    display: none;                                                     
                }
              `}
            </style>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({analyticalReducer}) => ({});

export default withPermissions(withRouter(connect(mapStateToProps, {})(ManualInvoiceList)));

